import { CostCode, CrewMember } from '@bechtel/types';

export enum TimesheetTabType {
  WORK_PACKAGES = 'WORK_PACKAGES',
  COST_CODES = 'COST_CODES',
}

export interface TimesheetCostCodeActionsProps {
  foreman: CrewMember;
  crewId: string | undefined;
  onCostCodeAdded: (selectedCostCodes: CostCode[]) => void;
  collapseAll: boolean;
  setCollapseAll: () => void;
  tsCostCodes: CostCode[];
}

export interface TimesheetTab {
  label: string;
  value: TimesheetTabType;
}
